<script>
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';

export default {
    data() {
        return {
            mobileLateralNavbarIsActive: false,
            userData: null,
            loader: true,
            showDebtWarningModal: false,
            showManagePaymentsMenu: false, // alterar para true para reexibir o menu
        }
    },
    created() {
        this.$axios.get('/user')
        .then(res => {
            this.userData = res.data;
            this.loader = false;
            
            // Verificar se é associado e está inadimplente
            if (res.data.role === 'associate' && res.data.financial_situation === 'Inadimplente') {
                // Verificar se já mostrou o modal nesta sessão
                const debtWarningShown = sessionStorage.getItem('debtWarningShown');
                if (!debtWarningShown) {
                    setTimeout(() => {
                        this.showDebtWarningModal = true;
                        sessionStorage.setItem('debtWarningShown', 'true');
                    }, 1500);
                }
            }
        })
        .catch(err => {
            this.notify('Erro ao buscar usuário!', 'error');
        });

        console.log(this.$route)
    },
    methods: {
        notify(text, type) {
            toast(text, {
                "type": type == 'info' ? 'info' : type == 'warning' ? 'warning' : type == 'error' ? 'error' : type == 'success' ? 'success' : 'default',
            });
        },
        logout() {
            // Remove o token do localStorage
            localStorage.removeItem('UAUTHTKKEY');
            
            // Remove o header Authorization do axios
            delete this.$axios.defaults.headers.common['Authorization'];
            
            // Redireciona para o login
            this.$router.push('/acessar');
            
            this.notify('Logout realizado com sucesso!', 'success');
        },
        openMobileLateralNavBar() {
            const mobileLateralNavbar =  document.getElementById("lateral-nav-bar");

            mobileLateralNavbar.style.margin = "auto";
            mobileLateralNavbar.style.width = "350px";
            
            this.mobileLateralNavbarIsActive = true;
        },
        closeMobileLateralNavBar() {
            const mobileLateralNavbar =  document.getElementById("lateral-nav-bar");
            
            mobileLateralNavbar.style.margin = "0px 0px 0px -358px";
            mobileLateralNavbar.style.width = "400px";

            this.mobileLateralNavbarIsActive = false;
        },
    }
}
</script>

<template>
    <section class="dashboard-bg">
        <section class="top-bar">
            <figure class="top-bar-figure">
                <img src="@/assets/logo2.png" alt="Logo Anipp">
            </figure>

            <section class="top-bar-icons">
                <a href="https://anipp.org.br/" target="_blank">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="icon">
                        <path stroke-linecap="round" stroke-linejoin="round" d="m2.25 12 8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25" />
                    </svg>
                </a>

                <router-link to="/informes">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="icon">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M12 7.5h1.5m-1.5 3h1.5m-7.5 3h7.5m-7.5 3h7.5m3-9h3.375c.621 0 1.125.504 1.125 1.125V18a2.25 2.25 0 0 1-2.25 2.25M16.5 7.5V18a2.25 2.25 0 0 0 2.25 2.25M16.5 7.5V4.875c0-.621-.504-1.125-1.125-1.125H4.125C3.504 3.75 3 4.254 3 4.875V18a2.25 2.25 0 0 0 2.25 2.25h13.5M6 7.5h3v3H6v-3Z" />
                    </svg>
                </router-link>

                <router-link to="/perfil">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="icon">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M17.982 18.725A7.488 7.488 0 0 0 12 15.75a7.488 7.488 0 0 0-5.982 2.975m11.963 0a9 9 0 1 0-11.963 0m11.963 0A8.966 8.966 0 0 1 12 21a8.966 8.966 0 0 1-5.982-2.275M15 9.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                    </svg>
                </router-link>

                <a @click="logout" class="logout-btn" title="Sair">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="icon">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 9V5.25A2.25 2.25 0 0 1 10.5 3h6a2.25 2.25 0 0 1 2.25 2.25v13.5A2.25 2.25 0 0 1 16.5 21h-6a2.25 2.25 0 0 1-2.25-2.25V15m-3 0-3-3m0 0 3-3m-3 3H15" />
                    </svg>
                </a>
            </section>
        </section>

        <section v-if="!loader" class="center-content">
            <section id="lateral-nav-bar" class="lateral-nav-bar">
                <!-- Barra lateral de administradores -->
                <header v-if="userData.role != 'associate'">
                    <h2>Painel de administradores:</h2>

                    <div @click="!mobileLateralNavbarIsActive ? openMobileLateralNavBar() : closeMobileLateralNavBar()" class="open-close-modal">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="icon">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
                        </svg>
                    </div>
                </header>

                <nav v-if="userData.role != 'associate'">
                    <div :class="this.$route.fullPath == '/inicio' ? 'active' : ''">
                        <router-link id="first-router-link" class="router-link" to="/inicio">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="icon">
                                <path stroke-linecap="round" stroke-linejoin="round" d="m2.25 12 8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25" />
                            </svg>

                            <p>Página inicial</p>
                        </router-link>
                    </div>

                    <div :class="this.$route.fullPath == '/associados' ? 'active' : ''">
                        <router-link class="router-link" to="/associados">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="icon">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M18 18.72a9.094 9.094 0 0 0 3.741-.479 3 3 0 0 0-4.682-2.72m.94 3.198.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0 1 12 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 0 1 6 18.719m12 0a5.971 5.971 0 0 0-.941-3.197m0 0A5.995 5.995 0 0 0 12 12.75a5.995 5.995 0 0 0-5.058 2.772m0 0a3 3 0 0 0-4.681 2.72 8.986 8.986 0 0 0 3.74.477m.94-3.197a5.971 5.971 0 0 0-.94 3.197M15 6.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm6 3a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Zm-13.5 0a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z" />
                            </svg>

                            <p>Associados</p>
                        </router-link>
                    </div>

                    <div :class="this.$route.fullPath == '/fluxo-de-caixa' ? 'active' : ''">
                        <router-link class="router-link" to="/fluxo-de-caixa">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="icon">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M21 12a2.25 2.25 0 0 0-2.25-2.25H15a3 3 0 1 1-6 0H5.25A2.25 2.25 0 0 0 3 12m18 0v6a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 18v-6m18 0V9M3 12V9m18 0a2.25 2.25 0 0 0-2.25-2.25H5.25A2.25 2.25 0 0 0 3 9m18 0V6a2.25 2.25 0 0 0-2.25-2.25H5.25A2.25 2.25 0 0 0 3 6v3" />
                            </svg>

                            <p>Fluxo de caixa</p>
                        </router-link>
                    </div>

                    <div :class="this.$route.fullPath == '/gerenciar-informes' ? 'active' : ''">
                        <router-link class="router-link" to="/gerenciar-informes">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="icon">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M12 7.5h1.5m-1.5 3h1.5m-7.5 3h7.5m-7.5 3h7.5m3-9h3.375c.621 0 1.125.504 1.125 1.125V18a2.25 2.25 0 0 1-2.25 2.25M16.5 7.5V18a2.25 2.25 0 0 0 2.25 2.25M16.5 7.5V4.875c0-.621-.504-1.125-1.125-1.125H4.125C3.504 3.75 3 4.254 3 4.875V18a2.25 2.25 0 0 0 2.25 2.25h13.5M6 7.5h3v3H6v-3Z" />
                            </svg>

                            <p>Gerenciar informes</p>
                        </router-link>
                    </div>

                    <div :class="this.$route.fullPath == '/gerar-parcelas' ? 'active' : ''">
                        <router-link class="router-link" to="/gerar-parcelas">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="icon">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h.008v.008H12v-.008ZM12 15h.008v.008H12V15Zm0 2.25h.008v.008H12v-.008ZM9.75 15h.008v.008H9.75V15Zm0 2.25h.008v.008H9.75v-.008ZM7.5 15h.008v.008H7.5V15Zm0 2.25h.008v.008H7.5v-.008Zm6.75-4.5h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V15Zm0 2.25h.008v.008h-.008v-.008Zm2.25-4.5h.008v.008H16.5v-.008Zm0 2.25h.008v.008H16.5V15Z" />
                            </svg>

                            <p>Gerar parcelas</p>
                        </router-link>
                    </div>

                    <div v-if="showManagePaymentsMenu" :class="this.$route.fullPath == '/gerenciar-pagamentos' ? 'active' : ''">
                        <router-link class="router-link" to="/gerenciar-pagamentos">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="icon">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 16.875h3.375m0 0h3.375m-3.375 0V13.5m0 3.375v3.375M6 10.5h2.25a2.25 2.25 0 0 0 2.25-2.25V6a2.25 2.25 0 0 0-2.25-2.25H6A2.25 2.25 0 0 0 3.75 6v2.25A2.25 2.25 0 0 0 6 10.5Zm0 9.75h2.25A2.25 2.25 0 0 0 10.5 18v-2.25a2.25 2.25 0 0 0-2.25-2.25H6a2.25 2.25 0 0 0-2.25 2.25V18A2.25 2.25 0 0 0 6 20.25Zm9.75-9.75H18a2.25 2.25 0 0 0 2.25-2.25V6A2.25 2.25 0 0 0 18 3.75h-2.25A2.25 2.25 0 0 0 13.5 6v2.25a2.25 2.25 0 0 0 2.25 2.25Z" />
                            </svg>

                            <p>Gerenciar pagamentos</p>
                        </router-link>
                    </div>

                    <div :class="this.$route.fullPath == '/relatorios' ? 'active' : ''">
                        <router-link class="router-link" to="/relatorios">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="icon">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
                            </svg>

                            <p>Relatórios</p>
                        </router-link>
                    </div>

                    <div :class="this.$route.fullPath == '/avisos-automaticos' ? 'active' : ''">
                        <router-link class="router-link" to="/avisos-automaticos">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="icon">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75" />
                            </svg>

                            <p>Avisos Automáticos</p>
                        </router-link>
                    </div>
                </nav>

                <!-- Barra lateral dos associados -->
                <header v-if="userData.is_associate">
                    <h2>
                        Painel de associados:
                        <span v-if="userData.financial_situation === 'Inadimplente'" class="debt-badge" title="Você possui débitos pendentes">
                            ⚠️
                        </span>
                    </h2>

                    <div v-if="userData.role == 'associate'" @click="!mobileLateralNavbarIsActive ? openMobileLateralNavBar() : closeMobileLateralNavBar()" class="open-close-modal">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="icon">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
                        </svg>
                    </div>
                </header>

                <nav v-if="userData.is_associate">
                    <div :class="this.$route.fullPath == '/inicio' ? 'active' : ''" v-if="userData.role == 'associate'">
                        <router-link id="first-router-link" class="router-link" to="/inicio">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="icon">
                                <path stroke-linecap="round" stroke-linejoin="round" d="m2.25 12 8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25" />
                            </svg>

                            <p>Página inicial</p>
                        </router-link>
                    </div>

                    <div :class="this.$route.fullPath == '/vida-financeira' ? 'active' : ''">
                        <router-link class="router-link" to="/vida-financeira">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="icon">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 18.75a60.07 60.07 0 0 1 15.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 0 1 3 6h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H20.25M2.25 6v9m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.504 1.125 1.125v9.75c0 .621-.504 1.125-1.125 1.125h-.375m1.5-1.5H21a.75.75 0 0 0-.75.75v.75m0 0H3.75m0 0h-.375a1.125 1.125 0 0 1-1.125-1.125V15m1.5 1.5v-.75A.75.75 0 0 0 3 15h-.75M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm3 0h.008v.008H18V10.5Zm-12 0h.008v.008H6V10.5Z" />
                            </svg>

                            <p>
                                Vida financeira
                                <span v-if="userData.financial_situation === 'Inadimplente'" class="debt-indicator">●</span>
                            </p>
                        </router-link>
                    </div>

                    <div :class="this.$route.fullPath == '/informes' ? 'active' : ''">
                        <router-link class="router-link" to="/informes">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="icon">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M12 7.5h1.5m-1.5 3h1.5m-7.5 3h7.5m-7.5 3h7.5m3-9h3.375c.621 0 1.125.504 1.125 1.125V18a2.25 2.25 0 0 1-2.25 2.25M16.5 7.5V18a2.25 2.25 0 0 0 2.25 2.25M16.5 7.5V4.875c0-.621-.504-1.125-1.125-1.125H4.125C3.504 3.75 3 4.254 3 4.875V18a2.25 2.25 0 0 0 2.25 2.25h13.5M6 7.5h3v3H6v-3Z" />
                            </svg>

                            <p>Informes</p>
                        </router-link>
                    </div>
                </nav>
            </section>

            <section class="center-content-section">
                <router-view :userData="userData"/>
            </section>
        </section>

        <!-- Modal de Aviso de Inadimplência -->
        <div v-if="showDebtWarningModal" class="modal-overlay" @click.self="showDebtWarningModal = false">
            <div class="modal-debt-warning">
                <div class="modal-header">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="warning-icon">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
                    </svg>
                    <h2>⚠️ Aviso Importante</h2>
                </div>
                
                <div class="modal-content">
                    <p class="greeting">Prezado(a) <strong>{{ userData.name }}</strong>,</p>
                    <p class="message">Identificamos que você possui débitos pendentes com a ANIPP.</p>
                    
                    <div class="debt-info">
                        <div class="info-item" v-if="userData.financial_situation_description">
                            <strong>Situação:</strong>
                            <span>{{ userData.financial_situation_description }}</span>
                        </div>
                        <div class="info-item" v-if="userData.previous_debts && userData.previous_debts > 0">
                            <strong>Valor pendente:</strong>
                            <span class="debt-value">R$ {{ userData.previous_debts.toFixed(2).replace('.', ',') }}</span>
                        </div>
                    </div>
                    
                    <p class="warning-text">Por favor, regularize sua situação para continuar usufruindo de todos os benefícios da associação.</p>
                </div>
                
                <div class="modal-actions">
                    <button class="btn-secondary" @click="showDebtWarningModal = false">Entendi</button>
                    <router-link to="/vida-financeira" @click="showDebtWarningModal = false">
                        <button class="btn-primary">Ver Meus Débitos</button>
                    </router-link>
                </div>
            </div>
        </div>
    </section>
</template>

<style scoped>
.top-bar {
    width: 100%;
    height: auto;
    padding: 25px 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #afafaf;
}

.top-bar-icons {
    display: flex;
}

.top-bar-icons a,
.top-bar-icons router-link {
    margin: 0px 6px;
    cursor: pointer;
}

.top-bar-icons a .icon,
.top-bar-icons router-link .icon {
    width: 26px;
    color: #2E2E2E;
}

.center-content {
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
}

.center-content .lateral-nav-bar {
    width: 400px;
    height: 100vh;
    border-right: 1px solid #afafaf;
    padding: 20px 0px;
    z-index: 1;
}

.center-content .lateral-nav-bar header {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.center-content .lateral-nav-bar header .open-close-modal {
    cursor: pointer;
    display: none;
}

.center-content .lateral-nav-bar header .open-close-modal .icon {
    width: 30px;
    margin-top: -5px;
    margin-right: 5px;
    color: #3a3a3a;
}

.center-content .lateral-nav-bar header h2 {
    font-size: 16px;
    font-weight: 600;
    margin-left: 20px;
    margin-right: 20px;
    margin-bottom: 14px;
    color: #3a3a3a;
}

.center-content .lateral-nav-bar nav {
    margin-bottom: 20px;
}

.center-content .lateral-nav-bar nav div {
    width: 100%;
    padding: 16px 0px;
}

.center-content .lateral-nav-bar nav .active {
    width: 90%;
    background-color: #D7C27B;
    border-radius: 0px 30px 30px 0px;
    transition: 0.3s
}

.center-content .lateral-nav-bar nav div .router-link {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-left: 20px;
}

.center-content .lateral-nav-bar nav div p {
    color: #2E2E2E;
    font-size: 16px;
    font-weight: 550;
    padding-left: 10px;
}

.center-content .lateral-nav-bar nav div .icon {
    width: 20px !important;
    color: #2E2E2E;
}

/* Badge de Inadimplência */
.debt-badge {
    display: inline-block;
    margin-left: 8px;
    font-size: 18px;
    animation: pulse-warning 2s infinite;
}

@keyframes pulse-warning {
    0%, 100% {
        transform: scale(1);
        opacity: 1;
    }
    50% {
        transform: scale(1.1);
        opacity: 0.8;
    }
}

.debt-indicator {
    display: inline-block;
    color: #ff5722;
    margin-left: 8px;
    font-size: 12px;
    animation: blink 2s infinite;
}

@keyframes blink {
    0%, 100% {
        opacity: 1;
    }
    50% {
        opacity: 0.3;
    }
}

.center-content-section {
    background-color: #F3F2F2;
    width: 90%;
    height: 100vh;
    overflow-y: auto;
    padding: 20px 20px 0px 25px;
}

@media screen and (max-width:970px) {
    .center-content-section {
        width: 100%;
        padding: 20px 20px 0px 70px;
    }

    .center-content .lateral-nav-bar nav .active {
        width: 80%;
        transition: 0.3s
    }

    .center-content .lateral-nav-bar {
        position: absolute;
        margin-left: -358px;
        background-color: #FFF;
    }

    .center-content .lateral-nav-bar header .open-close-modal {
        display: flex;
    }
}

/* Modal de Aviso de Inadimplência */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    animation: fadeIn 0.3s ease-in-out;
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

.modal-debt-warning {
    background: white;
    border-radius: 12px;
    padding: 0;
    max-width: 500px;
    width: 90%;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
    animation: slideUp 0.3s ease-out;
    overflow: hidden;
}

@keyframes slideUp {
    from {
        transform: translateY(50px);
        opacity: 0;
    }
    to {
        transform: translateY(0);
        opacity: 1;
    }
}

.modal-header {
    background: linear-gradient(135deg, #ff9800 0%, #ff5722 100%);
    color: white;
    padding: 25px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.modal-header .warning-icon {
    width: 50px;
    height: 50px;
    margin-bottom: 10px;
    animation: pulse 2s infinite;
}

@keyframes pulse {
    0%, 100% {
        opacity: 1;
    }
    50% {
        opacity: 0.6;
    }
}

.modal-header h2 {
    margin: 0;
    font-size: 24px;
    font-weight: 700;
}

.modal-content {
    padding: 30px;
}

.modal-content .greeting {
    font-size: 16px;
    margin-bottom: 15px;
    color: #333;
}

.modal-content .greeting strong {
    color: #D7C27B;
}

.modal-content .message {
    font-size: 15px;
    color: #555;
    margin-bottom: 20px;
    line-height: 1.6;
}

.debt-info {
    background: #fff3e0;
    border-left: 4px solid #ff9800;
    padding: 15px;
    margin: 20px 0;
    border-radius: 4px;
}

.debt-info .info-item {
    margin: 10px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.debt-info .info-item strong {
    color: #333;
    font-weight: 600;
}

.debt-info .info-item span {
    color: #666;
}

.debt-info .debt-value {
    color: #f44336;
    font-weight: 700;
    font-size: 18px;
}

.warning-text {
    font-size: 14px;
    color: #666;
    line-height: 1.6;
    margin-top: 15px;
}

.modal-actions {
    display: flex;
    gap: 10px;
    padding: 20px 30px 30px;
}

.modal-actions button {
    flex: 1;
    padding: 12px 20px;
    border: none;
    border-radius: 6px;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
}

.modal-actions .btn-secondary {
    background: #e0e0e0;
    color: #333;
}

.modal-actions .btn-secondary:hover {
    background: #d0d0d0;
}

.modal-actions .btn-primary {
    background: linear-gradient(135deg, #D7C27B 0%, #c4af68 100%);
    color: white;
}

.modal-actions .btn-primary:hover {
    background: linear-gradient(135deg, #c4af68 0%, #b39d5a 100%);
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(215, 194, 123, 0.4);
}

.modal-actions a {
    flex: 1;
    text-decoration: none;
}

@media screen and (max-width: 600px) {
    .modal-debt-warning {
        width: 95%;
        max-width: none;
    }
    
    .modal-actions {
        flex-direction: column;
    }
    
    .modal-actions a {
        width: 100%;
    }
}
</style>